module.exports = __webpack_public_path__ + "static/media/logo.8047570e.png";